import { useState } from "react";
import { ProductWarrantyStatusWidgetStyled, ModalBodyStyled } from "./styled";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Icons, Modals } from "components";

const ProductWarrantyStatusWidget = ({
  productWarrantyID,
  warranty_status,
  warranty_cancel_date,
  warranty_status_note,
  onUpdateSuccess,
}) => {
  const [_isBgLoading, _setIsBgLoading] = useState(false);
  const [_renderModal, _setRenderModal] = useState(false);

  const _handleClickModal = () => {
    _setRenderModal(
      <Forms.ProductWarrantyStatusForm
        inititalValues={{
          warranty_status,
          warranty_cancel_date,
          warranty_status_note,
        }}
        onCloseModal={_handleCloseModal}
        onSubmit={_handleSubmit}
      />
    );
  };
  const _handleCloseModal = () => {
    _setRenderModal(false);
  };

  const _handleSubmit = async (values) => {
    _setIsBgLoading(true);
    let params = {
      warranty_status: values.warranty_status,
    };
    if (values.warranty_cancel_date) {
      params.warranty_cancel_date = values.warranty_cancel_date;
    }
    if (values.warranty_status_note) {
      params.warranty_status_note = values.warranty_status_note;
    }
    let res = await portalService.PUT_PRODUCT_WARRANTEE_UPDATE(
      productWarrantyID,
      params
    );
    if (res && res.status === 200) {
      onUpdateSuccess && onUpdateSuccess();
      toast.success("อัพเดทสถานะสำเร็จ");
      _setIsBgLoading(false);
      _handleCloseModal();
    } else {
      _setIsBgLoading(false);
      toast.error("ไม่สามารถอัพเดทสถานะได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  return (
    <>
      <ProductWarrantyStatusWidgetStyled onClick={_handleClickModal}>
        Detail
        <Icons.Edit />
      </ProductWarrantyStatusWidgetStyled>
      <Modals.BodyEmpty
        isShowModal={_renderModal ? true : false}
        onCloseModal={_handleCloseModal}
      >
        <ModalBodyStyled>
          <Displays.BGLoading visible={_isBgLoading} />
          <div className="btn_close_modal" onClick={_handleCloseModal}>
            <Icons.CloseX />
          </div>
          {_renderModal}
        </ModalBodyStyled>
      </Modals.BodyEmpty>
    </>
  );
};

export default ProductWarrantyStatusWidget;
